<template>
  <el-table
    ref="multipleTable"
    :data="consignments"
    stripe
    :size="tableSize"
    @selection-change="handleSelectionChange"
  >
    <el-table-column
      label="Consignment"
    >
      <template v-slot="{ row }">
        <slot
          name="con_full"
          :consignment="row"
        >
          <ConsignmentLink :consignment="row">
            {{ row.con_full }}
          </ConsignmentLink>
        </slot>
      </template>
    </el-table-column>

    <el-table-column
      v-if="selectedColumns.includes('con_ref')"
      label="Reference"
      prop="con_ref"
      sortable
      show-overflow-tooltip
      :formatter="(row, col, cellValue) => cellValue ? (cellValue || '-') : '-'"
    />

    <el-table-column
      v-if="selectedColumns.includes('con_internal_ref')"
      label="Internal Reference"
      prop="con_internal_ref"
      show-overflow-tooltip
      :formatter="(row, col, cellValue) => cellValue ? (cellValue || '-') : '-'"
    />

    <el-table-column
      v-if="selectedColumns.includes('carrier')"
      label="Carrier"
      prop="carrier"
      sortable
      :sort-method="sortCarrier"
      show-overflow-tooltip
      :formatter="(row, col, cellValue) => cellValue ? (cellValue.name || '-') : '-'"
    />

    <el-table-column
      v-if="selectedColumns.includes('service')"
      label="Service"
      prop="service"
      sortable
      :sort-method="sortService"
      show-overflow-tooltip
      :formatter="(row, col, cellValue) => cellValue ? (cellValue.name + ' [' + cellValue.chainit + ']' || '-') : '-'"
    />

    <el-table-column
      v-if="selectedColumns.includes('account')"
      label="Account"
      sortable
      :sort-method="sortAccount"
    >
      <template v-slot="{ row }">
        <slot
          name="account"
          :consignment="row"
        >
          <router-link
            v-if="row.account"
            :to="{ name:'customerservice-accounts-account', params: { accountId: row.account.id } }"
          >
            {{ $_.get(row, 'account.name') || '-' }}
          </router-link>
        </slot>
      </template>
    </el-table-column>

    <el-table-column
      v-if="selectedColumns.includes('team')"
      label="Team"
      prop="team"
      sortabl
      show-overflow-tooltip
      :formatter="(row, col, cellValue) => cellValue ? (cellValue.name || '-') : '-'"
    />

    <el-table-column
      v-if="selectedColumns.includes('con_despatch_date')"
      label="Despatch Date"
      prop="con_despatch_date"
      sortable
      show-overflow-tooltip
      :formatter="(row, col, cellValue) => cellValue ? $moment(cellValue).format('DD-MM-YYYY HH:mm') : '-'"
    />

    <el-table-column
      v-if="selectedColumns.includes('con_manifest_date')"
      label="Manifest Date"
      prop="con_manifest_date"
      sortable
      show-overflow-tooltip
      :formatter="(row, col, cellValue) => cellValue ? $moment(cellValue).format('DD-MM-YYYY HH:mm') : '-'"
    />

    <el-table-column
      v-if="selectedColumns.includes('con_delivery_date')"
      label="Delivery Date"
      prop="con_delivery_date"
      sortable
      show-overflow-tooltip
      :formatter="(row, col, cellValue) => cellValue ? $moment(cellValue).format('DD-MM-YYYY HH:mm') : '-'"
    />

    <el-table-column
      v-if="selectedColumns.includes('con_sum_items')"
      label="Total Items"
      prop="con_sum_items"
      sortable
      show-overflow-tooltip
      :formatter="(row, col, cellValue) => cellValue ? (cellValue || '-') : '-'"
    />

    <el-table-column
      v-if="selectedColumns.includes('con_sum_weight')"
      label="Total Weight"
      prop="con_sum_weight"
      sortable
      show-overflow-tooltip
      :formatter="(row, col, cellValue) => cellValue ? (cellValue || '-') : '-'"
    />

    <el-table-column
      v-if="selectedColumns.includes('con_sum_cube')"
      label="Total Cube"
      prop="con_sum_cube"
      sortable
      show-overflow-tooltip
      :formatter="(row, col, cellValue) => cellValue ? (cellValue || '-') : '-'"
    />

    <el-table-column
      v-if="selectedColumns.includes('pickup')"
      label="Pickup"
      sortable
    >
      <template v-slot="{ row }">
        <slot
          name="pickup"
          :consignment="row"
        >
          <router-link
            v-if="row.pickup"
            :to="{ name:'customerservice-pickups-pickup', params: { pickupId: row.pickup.id } }"
          >
            {{ $_.get(row, 'pickup.reference') || '-' }}
          </router-link>
        </slot>
      </template>
    </el-table-column>

    <el-table-column
      v-if="selectedColumns.includes('zone_from')"
      label="Zone From"
      prop="zone_from"
      sortable
      show-overflow-tooltip
      :formatter="(row, col, cellValue) => cellValue ? (cellValue || '-') : '-'"
    />

    <el-table-column
      v-if="selectedColumns.includes('zone_to')"
      label="Zone To"
      prop="zone_to"
      sortable
      show-overflow-tooltip
      :formatter="(row, col, cellValue) => cellValue ? (cellValue || '-') : '-'"
    />

    <el-table-column
      v-if="selectedColumns.includes('authority_to_leave')"
      label="ATL"
      prop="authority_to_leave"
      sortable
      show-overflow-tooltip
      :formatter="(row, col, cellValue) => cellValue ? 'Yes' : 'No'"
    />

    <el-table-column
      v-if="selectedColumns.includes('con_is_dg')"
      label="DG"
      prop="con_is_dg"
      sortable
      show-overflow-tooltip
      :formatter="(row, col, cellValue) => cellValue ? 'Yes' : 'No'"
    />

    <el-table-column
      v-if="selectedColumns.includes('con_costcent')"
      label="Cost Centre"
      prop="con_costcent"
      sortable
      show-overflow-tooltip
      :formatter="(row, col, cellValue) => cellValue ? (cellValue || '-') : '-'"
    />

    <el-table-column
      v-if="selectedColumns.includes('con_special_instructions')"
      label="Instructions"
      prop="con_special_instructions"
      sortable
      show-overflow-tooltip
      :formatter="(row, col, cellValue) => cellValue ? (cellValue || '-') : '-'"
    />

    <el-table-column
      v-if="selectedColumns.includes('con_sender_name')"
      label="Sender"
      prop="con_sender_name"
      sortable
      show-overflow-tooltip
      :formatter="(row, col, cellValue) => cellValue ? (cellValue || '-') : '-'"
    />

    <el-table-column
      v-if="selectedColumns.includes('con_sender_address_1')"
      label="Sender Address 1"
      prop="con_sender_address_1"
      sortable
      show-overflow-tooltip
      :formatter="(row, col, cellValue) => cellValue ? (cellValue || '-') : '-'"
    />

    <el-table-column
      v-if="selectedColumns.includes('con_sender_address_2')"
      label="Sender Address 2"
      prop="con_sender_address_2"
      sortable
      show-overflow-tooltip
      :formatter="(row, col, cellValue) => cellValue ? (cellValue || '-') : '-'"
    />

    <el-table-column
      v-if="selectedColumns.includes('con_sender_town')"
      label="Sender Town"
      prop="con_sender_town"
      sortable
      show-overflow-tooltip
      :formatter="(row, col, cellValue) => cellValue ? (cellValue || '-') : '-'"
    />

    <el-table-column
      v-if="selectedColumns.includes('con_sender_state')"
      label="Sender State"
      prop="con_sender_state"
      sortable
      show-overflow-tooltip
      :formatter="(row, col, cellValue) => cellValue ? (cellValue || '-') : '-'"
    />

    <el-table-column
      v-if="selectedColumns.includes('con_sender_postcode')"
      label="Sender Postcode"
      prop="con_sender_postcode"
      sortable
      show-overflow-tooltip
      :formatter="(row, col, cellValue) => cellValue ? (cellValue || '-') : '-'"
    />

    <el-table-column
      v-if="selectedColumns.includes('con_sender_contact')"
      label="Sender Contact"
      prop="con_sender_contact"
      sortable
      show-overflow-tooltip
      :formatter="(row, col, cellValue) => cellValue ? (cellValue || '-') : '-'"
    />

    <el-table-column
      v-if="selectedColumns.includes('con_sender_phone')"
      label="Sender Phone"
      prop="con_sender_phone"
      sortable
      show-overflow-tooltip
      :formatter="(row, col, cellValue) => cellValue ? (cellValue || '-') : '-'"
    />

    <el-table-column
      v-if="selectedColumns.includes('con_sender_email')"
      label="Sender Email"
      prop="con_sender_email"
      sortable
      show-overflow-tooltip
      :formatter="(row, col, cellValue) => cellValue ? (cellValue || '-') : '-'"
    />

    <el-table-column
      v-if="selectedColumns.includes('con_sender_residential')"
      label="Sender Residential"
      prop="con_sender_residential"
      sortable
      show-overflow-tooltip
      :formatter="(row, col, cellValue) => cellValue ? 'Yes' : 'No'"
    />

    <el-table-column
      v-if="selectedColumns.includes('con_receiver_name')"
      label="Receiver"
      prop="con_receiver_name"
      sortable
      show-overflow-tooltip
      :formatter="(row, col, cellValue) => cellValue ? (cellValue || '-') : '-'"
    />

    <el-table-column
      v-if="selectedColumns.includes('con_receiver_address_1')"
      label="Receiver Address 1"
      prop="con_receiver_address_1"
      sortable
      show-overflow-tooltip
      :formatter="(row, col, cellValue) => cellValue ? (cellValue || '-') : '-'"
    />

    <el-table-column
      v-if="selectedColumns.includes('con_receiver_address_2')"
      label="Receiver Address 2"
      prop="con_receiver_address_2"
      sortable
      show-overflow-tooltip
      :formatter="(row, col, cellValue) => cellValue ? (cellValue || '-') : '-'"
    />

    <el-table-column
      v-if="selectedColumns.includes('con_receiver_town')"
      label="Receiver Town"
      prop="con_receiver_town"
      sortable
      show-overflow-tooltip
      :formatter="(row, col, cellValue) => cellValue ? (cellValue || '-') : '-'"
    />

    <el-table-column
      v-if="selectedColumns.includes('con_receiver_state')"
      label="Receiver State"
      prop="con_receiver_state"
      sortable
      show-overflow-tooltip
      :formatter="(row, col, cellValue) => cellValue ? (cellValue || '-') : '-'"
    />

    <el-table-column
      v-if="selectedColumns.includes('con_receiver_postcode')"
      label="Receiver Postcode"
      prop="con_receiver_postcode"
      sortable
      show-overflow-tooltip
      :formatter="(row, col, cellValue) => cellValue ? (cellValue || '-') : '-'"
    />

    <el-table-column
      v-if="selectedColumns.includes('con_receiver_contact')"
      label="Receiver Contact"
      prop="con_receiver_contact"
      sortable
      show-overflow-tooltip
      :formatter="(row, col, cellValue) => cellValue ? (cellValue || '-') : '-'"
    />

    <el-table-column
      v-if="selectedColumns.includes('con_receiver_phone')"
      label="Receiver Phone"
      prop="con_receiver_phone"
      sortable
      show-overflow-tooltip
      :formatter="(row, col, cellValue) => cellValue ? (cellValue || '-') : '-'"
    />

    <el-table-column
      v-if="selectedColumns.includes('con_receiver_email')"
      label="Receiver Email"
      prop="con_receiver_email"
      sortable
      show-overflow-tooltip
      :formatter="(row, col, cellValue) => cellValue ? (cellValue || '-') : '-'"
    />

    <el-table-column
      v-if="selectedColumns.includes('con_receiver_residential')"
      label="Receiver Residential"
      prop="con_receiver_residential"
      sortable
      show-overflow-tooltip
      :formatter="(row, col, cellValue) => cellValue ? 'Yes' : 'No'"
    />

    <el-table-column
      v-if="selectedColumns.includes('edi_id')"
      label="Manifested"
      prop="edi_id"
      width="150"
      :formatter="(row, col, cellValue) => cellValue ? 'Yes' : 'No'"
    />

    <el-table-column
      v-if="selectedColumns.includes('con_est_price')"
      label="Cost"
      prop="con_est_price"
      sortable
      :formatter="(row, col, cellValue) => cellValue ? '$' + cellValue : '-'"
    />

    <el-table-column
      v-if="!!$scopedSlots['actions']"
      label="Actions"
      align="right"
    >
      <template v-slot="{ row }">
        <slot
          name="actions"
          :consignment="row"
        />
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import ConsignmentLink from '@/components/Popovers/ConsignmentLink'

export default {
  components: {
    ConsignmentLink
  },
  props: {
    consignments: {
      type: Array,
      required: true
    },
    selectedColumns: {
      type: Array,
      required: true
    }
  },
  computed: {
    tableSize () {
      let configuration = this.$_.cloneDeep(this.$store.getters.configuration)
      if (this.$_.isEmpty(configuration.layout.tableSize)) {
        return 'default'
      } else {
        return configuration.layout.tableSize
      }
    }
  },
  methods: {
    sortCarrier (a, b) {
      return a.carrier.name.localeCompare(b.carrier.name)
    },
    sortAccount (a, b) {
      return a.account.name.localeCompare(b.account.name)
    },
    sortService (a, b) {
      return a.service.name.localeCompare(b.service.name)
    },
    toggleSelection (rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row)
        })
      } else {
        this.$refs.multipleTable.clearSelection()
      }
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    defaultFormatter (_row, _col, cellValue) {
      return cellValue || '-'
    },
    boolFormatter (_row, _col, cellValue) {
      return cellValue ? 'Yes' : 'No'
    },
    moneyFormatter (_row, _col, cellValue) {
      return cellValue ? `$${cellValue}` : '-'
    }
  }
}
</script>
